import React from 'react';
import { JcCommonProps, JcSize, JcUtils } from '../../utils/JcUtils';
import { JcImage, JcImageProps } from '../JcImage';
import { isJcBuiltInIcon, JC_BUILT_IN_ICONS, JcBuiltInIcon } from './JcBuiltInIcons';
import { JC_AVATAR_ICONS, JcAvatarIcon } from 'jcsdk';

export enum JcIconType {
  BUILT_IN = "BUILT_IN",
  CUSTOM = "CUSTOM",
}

export interface JcIconBaseProps extends JcCommonProps {
  readonly size?: JcSize;
}

export interface JcBuiltInIconProps extends JcIconBaseProps {
  readonly type: JcIconType.BUILT_IN;
  readonly icon: JcBuiltInIcon | JcAvatarIcon;
}

export interface JcCustomIconProps extends JcIconBaseProps {
  readonly type: JcIconType.CUSTOM;
  readonly imageProps: Omit<JcImageProps, "size">;
}

export type JcIconProps = JcBuiltInIconProps | JcCustomIconProps;

export const JcIcon: React.FunctionComponent<JcIconProps> = (props: JcIconProps) => {
  const size = props.size ?? JcSize.SMALL;

  const commonProps = JcUtils.commonProps(props, [
    "jc-icon",
    size !== JcSize.NONE && ("jc-icon-size-" + size),
  ]);

  if (props.type === JcIconType.CUSTOM) {
    const imageClassName = JcUtils.classNameString([props.imageProps.className, "jc-icon-img"]);
    return <div {...commonProps}>
      <JcImage {...props.imageProps} size={JcSize.NONE} className={imageClassName} />
    </div>;
  }

  const renderIcon = isJcBuiltInIcon(props.icon)
    ? JC_BUILT_IN_ICONS[props.icon]
    : JC_AVATAR_ICONS[props.icon];
  return <div {...commonProps}>
    {renderIcon({ className: "jc-icon-img", "aria-label": props.icon })}
  </div>;
}
